import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import moment from 'moment-timezone';
import DateUtils from 'utils/date_utils';
import { forwardPropsToState } from 'utils/react_utils';
import LecomLabel from '../../../form/components/label/label.jsx';
import { ModalEventHandler, ModalEvents } from '../../../modal/events/modal_event_handler';
import { FormEvents, FormEventHandler } from '../../../form/events/form_event_handler';
import { getParamUrl } from 'utils/query_string_parser';
import { getTimeZone } from 'utils/timeZone';
import { formatDate } from 'utils/formatting_utils';
import { formatDateToBasic } from 'utils/date_utils_new.js';
import { FormAPI } from 'lecom-api';

let dateInvalidValue = "";

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)
@mixin.decorate(window.UtilsMixin)
@forwardPropsToState([{ prop: 'value' }])

export default class InputDatepicker extends React.Component {
	static propTypes = {
		mask: PropTypes.string
	};

	static defaultProps = {
		themeClassKey: 'input.datepicker',
		//removeMaskOnChange: true,
		calendar: true
	};

	state = {
		inputMaskedKey: this.generateUUID()
	};

	constructor(props) {
		super(props);

		const currentLocale = Realize.i18n.currentLocale.toLowerCase();
		moment.locale(currentLocale);

		this.handleComplete = this.handleComplete.bind(this);
		this.handleCalendarClick = this.handleCalendarClick.bind(this);
		this.handleMaskIncomplete = this.handleMaskIncomplete.bind(this);
		this.handlePickadateSet = this.handlePickadateSet.bind(this);
	}

	componentDidMount() {
		setTimeout(() => {
			const value = (this.state.value == null) ? this.state.value: DateUtils.convertDateStringToISOString(this.state.value);

			if (value !== null && value !== undefined) {
				this.props.onChange(null, value);
			}
		}, 0);

		this.setPickadatePlugin();
		this.readOnlyInput();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.value !== this.state.value) {
			const value = this.getFormattedDateValue();
			this.props.onChange(null, value);
			this.isValidDate()
		}

		this.setPickadatePlugin();

		const $elemPicker = $('.' + this.props.id + '_root');
		$elemPicker.removeAttr('tabindex');


		if ($elemPicker.length > 1)
			$elemPicker.first().remove();

		if (prevState.dateInvalid !== this.state.dateInvalid) {
			const field = this.props.gridFormParent ? Form.fields(this.props.gridFormParent).fields(this.props.id) : Form.fields(this.props.id);

			if (field) {
				if (this.state.dateInvalid) {
					field.errors(`${dateInvalidValue} ${Realize.i18n.t('general.date.invalid')}`).apply();
				}
				else {
					field.errors("").apply();
				}
			}
		}
	}

	isValidDate(value){
		let date = value || this.state.value || "";

		if (date && typeof date === "string") {
			if (date.search("T") > 0) {
				const dt = date.split('T');
				date = dt[0];
			}
			else if (date.search('/') > 0) {
				const currentLocale = Realize.i18n.currentLocale.toLowerCase();
				const arrDate = date.split('/');

				if (currentLocale === 'pt-br' || currentLocale === 'es')
					date = arrDate[2] + '-' + arrDate[1] + '-' + arrDate[0];
				else
					date = arrDate[2] + '-' + arrDate[0] + '-' + arrDate[1];
			}

			const dateUser = moment(date);

			if (dateUser.isValid()) {
				dateInvalidValue = "";
				this.setState({ dateInvalid: false });
			}
			else {
				if(dateInvalidValue === "" || (this.state.value !== "" && dateInvalidValue !== this.state.value))
					dateInvalidValue = this.state.value;
				this.setState({ dateInvalid: true, value: "" });
			}
		}
		else if (date && typeof date === "number") {
			const dateUser = moment(date);

			if (dateUser.isValid()) {
				dateInvalidValue = "";
				this.setState({ dateInvalid: false });
			}
			else {
				if(dateInvalidValue === "" || (this.state.value !== "" && dateInvalidValue !== this.state.value))
					dateInvalidValue = this.state.value;
				this.setState({ dateInvalid: true, value: "" });
			}
		}
	}

	getDateFormat() {
		return (this.props.dateFormat || Realize.i18n.t('date.formats.date'));
	}

	getFormattedDateValue() {
		const { value } = this.state;		
		let formatTestedValue = value;
		const YYYYMMDD = new RegExp(/^\d{4}(((0)[0-9])|((1)[0-2]))([0-2][0-9]|(3)[0-1])$/i);		
		
		if (YYYYMMDD.test(formatTestedValue)) {						
			formatTestedValue = `${formatTestedValue.slice(0, 4)}-${formatTestedValue.slice(4, 6)}-${formatTestedValue.slice(6, 8)}`			
		}		

		const dateFormatted = formatDateToBasic(formatTestedValue, this.getDateFormat());				

		if (dateFormatted === null || dateFormatted === undefined) {
			return "";
		}

		return dateFormatted;
	}

	getParsedDateValue() {
		return DateUtils.convertDateStringToISOString(this.state.value);
	}

	labelIsActive() {
		const inputValue = this.state.value;
		return (inputValue != null && String(inputValue).length > 0);
	}

	setPositionTopCss(windowHeight, inputNodeTop, pickerFrame, pickerFrameHeight) {
		if (inputNodeTop < (pickerFrameHeight/2) || !window.parent.frames.length)
			pickerFrame.css("top", "50px");
		else
			((windowHeight - inputNodeTop) < pickerFrameHeight)
				? pickerFrame.css("top", (inputNodeTop - pickerFrameHeight) + "px")
				: pickerFrame.css("top", inputNodeTop + "px");
	}

	changePositionPicker(picker, inputNode) {
		const windowHeight = window.innerHeight;
		const inputNodeTop = inputNode.offset().top;
		const pickerFrame = picker.$root.find(".picker__frame");
		const pickerFrameHeight = pickerFrame.height();

		FormEventHandler.publish(FormEvents.DATE_PICKER_OPEN, inputNodeTop);

		this.setPositionTopCss(windowHeight, inputNodeTop, pickerFrame, pickerFrameHeight);
	}

	setTopPicker(inputNode) {
		if(inputNode.length > 0){
			inputNode.pickadate('picker').$root.css('top', inputNode.offset().top + 'px');
			inputNode.pickadate('picker').$root.removeAttr('tabindex');
		}
	}

	/* Pickadate handlers */

	setPickadatePlugin() {
		const $inputNode = $(ReactDOM.findDOMNode(this.refs.input));
		const self = this;
		const options = {
			editable: true,
			selectMonths: true,
			selectYears: 150,
			format: this.getDateFormat().toLowerCase(),
			onSet: this.handlePickadateSet,
			klass: {
				picker: 'picker ' + self.props.id + '_root',
			},
			container: 'body',
			containerHidden: 'body',
			onOpen: function () {
				if (self.props.disabled || self.props.readOnly || !self.props.visible) {
					this.close();
				}
				else {
					/* Foi usado timeout para pegar a altura do picker, pois a lib nao contem um metodo de callback acertivo */
					if (!(getParamUrl("newWS") === "true"))
						setTimeout(() => self.changePositionPicker(this, $inputNode), 100);
				}
			},
			onClose: () => {
				let idInput = this.props.id;

				let modalDocumentVisible = $('#documentModal').is(':visible');
				if(modalDocumentVisible === true){
					let positionModalDoc = $('#documentModal').position().top;
					FormEventHandler.publish(FormEvents.DATE_PICKER_CLOSE, positionModalDoc);
				} else
					FormEventHandler.publish(FormEvents.DATE_PICKER_CLOSE, $inputNode.offset().top);

				$(document.activeElement).blur();

				/* Foi usado timeout para pegar a altura do picker, pois a lib nao contem um metodo de callback acertivo */
				setTimeout(() => $(`#${idInput}`).focus() , 100);
			}
		};

		$inputNode.pickadate(Object.assign({}, options, Realize.i18n.t('datepicker')));
		$inputNode.removeAttr('tabindex');

		if (this.props.id !== this.props.name)
			ModalEventHandler.subscribe(ModalEvents.MODAL_OPENED, this.setTopPicker.bind(this, $inputNode));
		else
			this.setTopPicker($inputNode);

		$inputNode.inputmask({
			mask: "99/99/9999",
			oncomplete: this.handleComplete.bind(this),
			onincomplete: this.handleMaskIncomplete.bind(this),
			showMaskOnHover: false
		});
	}

	tabOrderCalendar(type){
		const idInput = this.props.id;
		const node = $(`#${idInput}_root`);

		if(node.is(':visible') === true) {

			if(type === 'year') $('.picker__select--year').focus();
			else $('.picker__select--month').focus();

			$(`#${idInput}_table tr td`).attr('tabindex', 0);

			$(`#${idInput}_table tr td`).unbind('keydown').keydown((e) => {
				if(e.keyCode === 13 || e.which === 13){
					e.currentTarget.childNodes[0].click();

					$(`#${idInput}`).focus();
				}
			});

			$('.picker__footer .picker__close').unbind('keydown').keydown((e) => {
				if(e.shiftKey){
					return true
				}

				if(e.which === 9 || e.keyCode === 9 ){
					$('.picker__select--month').focus();
					return false
				}
			});

			$('.picker__select--month').unbind('keydown').keydown((e) => {
				if(e.shiftKey && e.keyCode === 9)
					return false
			});

			node.find(".picker__select--year").change((e) => {
				setTimeout(()=>{
					this.tabOrderCalendar('year');
				}, 0);
				node.find(".picker__select--year").focus();
			});

			node.find(".picker__select--month").change((e) => {
				setTimeout(()=>{
					this.tabOrderCalendar('month');
				}, 0);
				node.find(".picker__select--month").focus();
			});
		}
	}

	handleCalendarClick(event) {
		const $inputNode = $(ReactDOM.findDOMNode(this.refs.input));
		const picker = $inputNode.pickadate('picker');

		setTimeout(() => { this.tabOrderCalendar() }, 500);

		/* TODO: should close on date click - materialize currently broke it
		Foi usado timeout para corrigir o problema de perda de foco do picker, o metodo de close estava sendo chamado duas vezes apos o open */
		(picker.get('open'))
			? picker.close()
			: setTimeout(() => picker.open(), 100);

		event.stopPropagation();

		const field = this.getFieldAPI();

		if (field) {
			field.publish(FormEvents.CLICK);
		}
	}

	handlePickadateSet(pickadateObject) {
		const pickedDate = pickadateObject.select;
		if(!pickedDate && !pickadateObject.hasOwnProperty("clear"))
			return;

		const value = !!pickedDate ? (typeof pickadateObject.select === "object" ? pickadateObject.select.pick : pickadateObject.select) : "";

		$(ReactDOM.findDOMNode(this.refs.input)).pickadate('close');

		this.setState({ inputMaskedKey: this.generateUUID(), value });
	}

	/* Mask event handlers */

	handleMaskIncomplete(event) {
		this.setState({value: ""});
	}

	handleComplete(event) {
		const { value } = event.target;
		this.setState({ value});
		this.isValidDate(value);

	}

	serialize() {
		const inputName = (this.props.name || this.props.id);

		const serializedInput = {};
		serializedInput[inputName] = this.getParsedDateValue();
		return serializedInput;
	}

	renderCalendar() {
		return this.props.calendar ? "" : " hide";
	}

	inputCssStyle() {
		const readOnly = this.props.readOnly;
		const cssStyle = {};

		if(readOnly === true){
			// cssStyle.backgroundColor = 'white';
			cssStyle.cursor = 'auto'
			return cssStyle;
		}
	}

	tabReadOnly(){
		let readOnly = this.props.readOnly;

		if(readOnly){
			let input = $(`#${this.props.id}`);
			input.prop('readonly', true);
		}

		let buttonDate = $('.button-date');

        if(buttonDate.length > 0){
            buttonDate.keydown((e) => {
                if(e.keyCode === 32)
                    return false
            })
        }
	}

	readOnlyInput(){
		const readOnly = this.props.readOnly;

		if(readOnly === true){
			let idField = this.props.id;
			$(`#input__${idField} input`).removeAttr('disabled');
			$(`#input__${idField} input`).attr('readonly', true)
		}
	}

	classActionButton(){
		if(this.props.actions.length !== 0)
			return 'datepicker-button-action'
		else
			return ''
	}

	getFieldAPI() {
		if (this.props.formId) {
			const formAPI = FormAPI.form(this.props.formId);

			return (this.props.gridFormParent)
				? formAPI.fields(this.props.gridFormParent).fields(this.props.id)
				: formAPI.fields(this.props.id);
		}

		return null;
	}

	render() {
		const {dateInvalid} = this.state;
		setTimeout(() => { this.tabReadOnly() }, 300);

		return (
			<div>
				<LecomLabel {...this.propsWithoutCSS()}
					id={this.props.id}
					active={this.labelIsActive()}
					key={`lecom--label__${this.props.id}`}
					className={this.props.readOnly ? "label-datepicker-readonly":""}
				/>
				<input
					{...this.props}
					style={this.inputCssStyle()}
					disabled={this.props.disabled && this.props.disabled === true ? this.props.disabled : ''}
					readOnly={this.props.readOnly}
					value={this.getFormattedDateValue()}
					className={this.props.readOnly ? `${this.inputClassName()} input-datepicker-readonly`: `${this.inputClassName()} ${dateInvalid && 'invalidinput-text'}`}
					key={this.state.inputMaskedKey}
					type="text"
					ref="input"
					placeholder={this.getDateFormat()}
					aria-labelledby={`${this.props.id}-${this.props.formId}`}
					aria-describedby="title format"
				/>
				<Button
					disabled={this.props.disabled || this.props.readOnly}
					icon={{type: "calendar"}}
					role='button'
					className={`input-datepicker__button prefix${this.renderCalendar()} button-date ${this.classActionButton()}`}
					onClick={this.handleCalendarClick}
					type="button"
					ref="button"
				/>

				<span id="title" className="hidden">{Realize.i18n.t('general.date.format_date')}</span>
				<span id="format" className="hidden">{Realize.i18n.t('general.date.format')}</span>
				<span id="prazomsg" aria-live="assertive" className="error hidden-reader"></span>
			</div>
		);
	}
}
